function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
}
export default hasClass;
//# sourceMappingURL=hasClass.js.map